const WechatOutline = ({ height = "512", width = "512", fill = "none" }) => (
  <svg
    height={height}
    width={width}
    fill={fill}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M235.3 17.1C339.7 20.6 447.6 106.6 429.6 219C429.1 222.4 431.2 223.4 433.2 224.7C454.6 239.1 471.8 257.4 483.1 280.7C507.1 330.2 498.4 386.6 460.3 426.6C454.2 433 451.1 438.7 452.7 447.8C455.2 463 456.2 478.2 457.5 493.6C445.9 489.5 407.6 462.7 400.3 466.9C317 499.1 211.7 463.5 182.8 374.7C182 372.2 181 370.8 178.3 370.2C166.6 367.2 155 363.8 143.4 360.8C141.4 360.3 138.7 360.4 136.9 361.4C117.6 371.4 99.1004 381.7 79.7004 391.7C81.7004 372.7 83.1004 355 85.5004 336.3C86.2004 331.4 84.7004 328.4 80.9004 325.3C-68.2996 198.1 61.8004 6.19999 235.3 17.1ZM404 208.3C414.6 94.3 283.8 24.7 183.5 47.9C48.6004 68.4 -12.8996 231 109 313.6C118.2 319.9 110.8 334.1 111.4 344.6C121 341 134.2 328.6 142.7 331.9C153.9 335.9 165.2 339.5 176.8 343.4C173.5 228.5 306.4 168.2 404 208.3ZM425.8 446.6C425.2 434.9 420.1 423.6 432.8 416.7C556.2 290 348.1 155.3 239.2 259.5C131.4 367.6 286.9 497.6 401.7 437.6C410.1 434.4 417.5 443.7 425.8 446.6Z"
      fill={fill}
    />
    <path
      d="M156.999 176.7C142.299 176.8 130.199 164.9 130.199 150.2C130.199 135.4 142.099 123.5 156.899 123.6C171.499 123.6 183.299 135.3 183.499 149.9C183.599 164.4 171.599 176.6 156.999 176.7Z"
      fill={fill}
    />
    <path
      d="M317.399 150.2C317.399 165 305.499 176.8 290.599 176.7C275.899 176.6 264.199 164.6 264.299 149.7C264.399 135.1 276.199 123.5 290.799 123.5C305.799 123.5 317.499 135.2 317.399 150.2Z"
      fill={fill}
    />
    <path
      d="M306.901 308.9C306.801 320.7 297.301 330.1 285.501 330C273.701 329.9 264.401 320.4 264.501 308.5C264.601 296.8 274.301 287.2 285.901 287.3C297.601 287.5 307.001 297.1 306.901 308.9Z"
      fill={fill}
    />
    <path
      d="M388.1 330C376.3 330.1 366.7 320.7 366.6 308.9C366.5 297.3 376.1 287.5 387.7 287.4C399.3 287.3 409 296.9 409.1 308.6C409.3 320.3 399.8 329.9 388.1 330Z"
      fill={fill}
    />
  </svg>
);

export default WechatOutline;
